// extracted by mini-css-extract-plugin
module.exports = {"styles":"m4Y-llcthn_vVs9bafl27"};